export function quotaToPercent(quota: number): number {
  if (!Number.isFinite(quota)) {
    return 0;
  }
  const asPercent = quota <= 1 ? Math.round(quota * 100) : Math.round(quota);
  return Math.min(100, Math.max(0, asPercent));
}
